import { render, staticRenderFns } from "./StandardTab.vue?vue&type=template&id=4127e9e8"
import script from "./StandardTab.vue?vue&type=script&lang=js"
export * from "./StandardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4127e9e8')) {
      api.createRecord('4127e9e8', component.options)
    } else {
      api.reload('4127e9e8', component.options)
    }
    module.hot.accept("./StandardTab.vue?vue&type=template&id=4127e9e8", function () {
      api.rerender('4127e9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/StandardTab.vue"
export default component.exports